import { CircularProgress, CircularProgressProps, circularProgressClasses, styled } from '@mui/joy';

/**
 * Spinner component
 * @param props per CircularProgressProps from Joy
 */
const Spinner = (props: CircularProgressProps) => <SpinnerStyled variant="soft" {...props} />;

export default Spinner;

const SpinnerStyled = styled(CircularProgress)`
  & .${circularProgressClasses.track} {
    stroke: ${({ theme }) => theme.vars.palette.grey2};
  },

  & .${circularProgressClasses.progress} {
    stroke: ${({ theme }) => theme.vars.palette.grey4};
  },
`;
